import React, { FC } from 'react';
import Button from '../../components/Button';
import styles from './styles/index.module.scss'

const Error404: FC = () => {
    return (
        <div className={styles['wrap']}>
            <div className={styles['info-block']}>
                <h1 className={styles['info-block--title']}>Страница не найдена</h1>
                <p className={styles['info-block--desc']}>
                    Страница, которую вы ищите, не существует,
                    возможно она устарела или была удалена.
                </p>
                <div className={styles['actions']}>
                    <Button
                        href='/'
                        className={styles['actions--btn']}
                    >
                        Вернуться на главную
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Error404;